var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Heading',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"subtitle-icon":"o_place","hide-back":true,"hide-nav":false}})}
var staticRenderFns = []

export { render, staticRenderFns }